module.exports = __webpack_public_path__ + "static/media/Default.673a914b.svg";